import Vue from "vue";
import Vuex from "vuex";

// Modules
import globals from "@/vuex/globals";
import me from "@/vuex/account/me";
import folders from "@/vuex/folder/folders";
import documents from "@/vuex/folder/documents";
import users from "@/vuex/setting/users";
import citizens from "@/vuex/setting/citizens";
import employees from "@/vuex/setting/employees";
import roles from "@/vuex/setting/roles";
import administrativeUnits from "@/vuex/setting/administrative_units";
import notices from "@/vuex/setting/notices";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    globals,
    me,
    folders,
    users,
    citizens,
    documents,
    employees,
    roles,
    administrativeUnits,
    notices
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js